export function applyTax(options) {
    const { amountInCents, taxRate } = options;
    if (!amountInCents) {
        return undefined;
    }
    if (!taxRate) {
        return amountInCents;
    }
    if (taxRate.inclusive === false) {
        return amountInCents + (amountInCents * taxRate.percentage) / 100;
    }
    return amountInCents;
}
export function getTaxAmount(options) {
    const { amountInCents, taxRate } = options;
    if (!amountInCents) {
        return undefined;
    }
    if (!taxRate) {
        return amountInCents;
    }
    if (taxRate.inclusive === false) {
        return (amountInCents * taxRate.percentage) / 100;
    }
    return amountInCents - amountInCents / (1 + taxRate.percentage / 100);
}
export function formatPrice(options) {
    const { amountInCents, currency, language } = options;
    if (!amountInCents || !currency || !language) {
        return '0';
    }
    const numberFormat = new Intl.NumberFormat(language, {
        style: 'currency',
        currency,
        currencyDisplay: 'code',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    });
    return numberFormat.format(amountInCents / 100);
}
export const isYearlyPrice = (options) => {
    const { interval, intervalCount } = options;
    return intervalCount === 1 && interval === 'YEAR';
};
export const isMonthlyPrice = (options) => {
    const { interval, intervalCount } = options;
    return intervalCount === 1 && interval === 'MONTH';
};
